import { toSlug } from "../utils/slugify";
import { getCityCountry } from "./cityCountry";

export const getCountries = () => {
  const record: Record<string, { lat: string; lng: string }> = {};

  getCityCountry().forEach(({ country, lat, lng }) => {
    if (country in record) {
      return;
    }
    record[country] = { lat, lng };
  });

  return Object.entries(record).map(([country, props]) => ({
    country,
    ...props,
  }));
};

export const getCityCountryKV = () => {
  const record: Record<
    string,
    { city?: string; country: string; lat: string; lng: string }
  > = {};

  getCountries().forEach(({ country, lat, lng }) => {
    const href = `/${toSlug(country)}`;

    if (href in record) {
      return;
    }

    record[href] = { country, lat, lng };
  });

  getCityCountry().forEach(({ city, country, lat, lng }) => {
    const href = `/${toSlug(country)}/${toSlug(city)}`;

    if (href in record) {
      return;
    }

    record[href] = { city, country, lat, lng };
  });

  return JSON.stringify(record);
};

const countries = getCountries();
const cityCountries = getCityCountry();

export function getCountryInfoForParam(countryParam: string | undefined) {
  if (!countryParam) {
    return null;
  }
  return countries.find((c) => toSlug(countryParam) === toSlug(c.country));
}

export function getCityInfoForParam({
  cityParam,
  countryParam,
}: {
  countryParam: string | undefined;
  cityParam: string | undefined;
}) {
  if (!cityParam || !countryParam) {
    return null;
  }
  return cityCountries.find(
    (c) =>
      toSlug(cityParam) === toSlug(c.city) &&
      toSlug(countryParam) === toSlug(c.country),
  );
}
